import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from './context/ThemeContext'
import { ViewModeProvider } from './context/ViewModeContext'
import { FormModalProvider } from './context/FormModalContext'
import FormModal from './components/FormModal'
import AppRoutes from './AppRoutes'

export default function App() {
  return (
    <ThemeProvider>
      <ViewModeProvider>
        <FormModalProvider>
          <BrowserRouter>
            <AppRoutes />
            {/* Mounted once, above everything — the SideShift-style
                popup any "Start My Website" / "Apply" button opens.
                Lives outside AppRoutes so navigation (e.g. the redirect
                to /thank-you on submit) doesn't unmount it mid-close. */}
            <FormModal />
          </BrowserRouter>
        </FormModalProvider>
      </ViewModeProvider>
    </ThemeProvider>
  )
}
